import { render, staticRenderFns } from "./newGroupType.vue?vue&type=template&id=a7e76924&"
import script from "./newGroupType.vue?vue&type=script&lang=js&"
export * from "./newGroupType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports